import type {DynamicLabelExtra} from 'src/action-creators/dynamic-labels';
import type {EntityType} from 'src/types/ats-entities';
import type {Props as TokenListInputProps} from 'src/components/lib/token-list-input/token-list-input.old';

import * as React from 'react';

import {dedupBridgedDynamicLabels} from 'src/utils/dynamic-labels';
import classify from 'src/utils/classify';

import TokenListInput from 'src/components/lib/token-list-input/token-list-input.old';
import {MultiEntityLabel} from 'src/components/lib/markdown-editor/dynamic-text';
import PlaceholderPill from 'src/components/lib/markdown-editor/placeholder-pill';
import {VariablePickerDropdownRow} from 'src/components/lib/variable-picker/variable-picker-dropdown-row';

import css from './variable-picker.css';


function MultiEntityVariableSelect({
  className,
  containerClassName,
  baseEntityType,
  values = [],
  onChange,
  options,
  limit,
  ...props
}: // @ts-expect-error - TS2314 - Generic type 'Props' requires 3 type argument(s).
TokenListInputProps & {
  options: DynamicLabelExtra[];
  baseEntityType: EntityType;
  value?: string;
}) {
  /*
  const dispatch = useDispatch();
  React.useEffect(() => {
    //
    dispatch(getAllEntities());
    dispatch(getAllEntityAttributes());
    dispatch(getGlobalVariables());
  }, [dispatch, getAllEntities, getAllEntityAttributes, getGlobalVariables]);
*/

  options = React.useMemo(
    // @ts-expect-error - TS2769 - No overload matches this call.
    () => Array.from(dedupBridgedDynamicLabels(options)),
    [options],
  );

  // Support a single 'value' prop for backward compatibility with Select
  const singleStringValue = 'value' in props;
  let onChangeOverride;

  if (singleStringValue) {
    const {value} = props;
    onChangeOverride = ([selection]: [any]) => {
      onChange(selection);
    };
    values = value?.length
      ? // @ts-expect-error - TS7031 - Binding element 'searchValue' implicitly has an 'any' type.
        options.filter(({value: searchValue}) => value === searchValue)
      : [];
    limit = 1;
  }

  return (
    <TokenListInput
      {...props}
      containerClassName={classify(
        css.multiEntityVariableSelectContainer,
        containerClassName,
      )}
      optionsContainerClassName={css.multiEntityVariableSelectOptions}
      groupOptionsBy="mapping.display_name"
      sortOptionsBy={(a, b) =>
        // @ts-expect-error - TS18046 - 'a' is of type 'unknown'. | TS18046 - 'a' is of type 'unknown'.
        (a.entityRelationshipPath?.[0] || a.name).localeCompare(
          // @ts-expect-error - TS18046 - 'b' is of type 'unknown'. | TS18046 - 'b' is of type 'unknown'.
          b.entityRelationshipPath?.[0] || b.name,
          'en',
          {
            sensitivity: 'base',
          },
        )
      }
      options={options}
      values={values}
      limit={limit}
      onChange={onChangeOverride || onChange}
      TokenComponent={MultiEntityLabel}
      PlaceholderComponent={PlaceholderPill}
      Suggestion={VariablePickerDropdownRow}
      suggestionExtras={{entityType: baseEntityType}}
      searchOnEmptyString
      openOnFocus
    />
  );
}

export default MultiEntityVariableSelect;
